import { CircularProgress, Typography } from '@mui/material';
import React from 'react';

// import imageLoader from '../assets/images/Liberty-loader.gif';
type Props = {
  pageCenterLoadingHide?: boolean;
  className?: string;
  loaderColor?: string;
  newLoader?: boolean;
};
export const Loader: React.FC<Props> = (props: Props) => {
  const {
    pageCenterLoadingHide = false,
    className = '',
    loaderColor,
    newLoader,
  } = props;
  return (
    <Typography
      component={'div'}
      className={className}
      sx={{
        ...(pageCenterLoadingHide
          ? {}
          : {
              left: ' 50%',
              position: 'fixed',
              top: ' 50%',
              transform: 'translate(-50%, -50%)',
            }),
        ...(newLoader
          ? {
              alignItems: 'center',
              display: 'flex',
              fontSize: '12px',
              gap: '8px',
              justifyContent: 'center',
            }
          : {}),
      }}>
      <CircularProgress
        sx={{ color: loaderColor ? loaderColor : '#340000' }}
        size={newLoader ? 20 : 80}
      />
      {newLoader && 'Loading...'}
    </Typography>
  );
};
